module.exports = {
  getUserGear: function (params, config) {
    const _config = config || { params }
    return this.client.get(`/v${this.v}/usergear/`, _config)
  },
}
